export default "__VITE_ASSET__CPUWp8XX__"